(function() {
  'use strict';

  function Coleta(Encomenda, Pedido) {

    var Coleta = {};

    Coleta.isColetaAtrasada = function() {
      return Pedido.ultimaIncompleta()
        .then(function(pedido){ 
            if (pedido.io) {
              return Pedido.getPedidoPorId(pedido.id); 
            }
          })
        .then(function(pedido){
          if(pedido && pedido.dataHoraAgendamentoColeta) {
            var hoje = moment(new Date()).format('YYYYMMDD');
            return moment(pedido.dataHoraAgendamentoColeta).isBefore(hoje);
          }
          return false;
        })
        .catch(function(err) { return false; });
    }

    Coleta.getData = function(dataHoraAgendamentoColeta, horarios) {
      if(!dataHoraAgendamentoColeta)
        return horarios[0];

      var data = moment(dataHoraAgendamentoColeta).format('YYYYMMDD');

      var dataEncontrada = horarios.filter(function(horario){
        return horario.data == data;
      });

      if(dataEncontrada.length > 0)
        return dataEncontrada[0];

      return horarios[0];
    }

    Coleta.getHoraRange = function(dataHoraAgendamentoColeta, horarios) {
      if(!dataHoraAgendamentoColeta)
        return null;

      var horaInicial = parseInt(moment(dataHoraAgendamentoColeta).format("HH"));
      var data = Coleta.getData(dataHoraAgendamentoColeta, horarios);

      var horarioEncontrado = data.horarios.filter(function(range){
        return range.inicio == horaInicial;
      });

      if(horarioEncontrado.length > 0)
        return horarioEncontrado[0];

      return {
        inicio: horaInicial,
        fim: horaInicial + 2
      };
    }

    Coleta.toInitialDate = function(data, hora) {
      var date = moment(data.data).utcOffset(0);
      date.set({hour: hora.inicio, minute: 0, second: 0});
      return date.format('YYYY-MM-DD HH:mm:SS');
    }

    Coleta.toFinalDate = function(data, hora) {
      var date = moment(data.data).utcOffset(0);
      date.set({hour: hora.fim, minute: 0, second: 0});
      return date.format('YYYY-MM-DD HH:mm:SS');
    }

    Coleta.uuidv4 = function() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    return Coleta;

  }

  angular
    .module('mandaeApp')
    .factory('Coleta', Coleta);

}());
